import api from './api';
import API_ROUTES from './apiRoutes';

const scrapeJobService = {
  // Get all scrape jobs with pagination
  getScrapeJobs: async (params = {}) => {
    const { page = 1, limit = 10 } = params;
    const response = await api.get(API_ROUTES.SUPER_ADMIN.GET_SCRAPE_JOBS, {
      params: { page, limit }
    });
    return response.data;
  },

  // Get scrape job by ID
  getScrapeJobById: async (id) => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.GET_SCRAPE_JOB_BY_ID(id));
    return response.data;
  },

  // Update scrape job
  updateScrapeJob: async (id, jobData) => {
    const response = await api.patch(API_ROUTES.SUPER_ADMIN.UPDATE_SCRAPE_JOB(id), jobData);
    return response.data;
  },

  // Delete scrape job
  deleteScrapeJob: async (id) => {
    const response = await api.delete(API_ROUTES.SUPER_ADMIN.DELETE_SCRAPE_JOB(id));
    return response.data;
  },
};

export default scrapeJobService;
